'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fill", "height", "rowHeight", "rowMinWidth", "rowPaddingX", "width"];
import PropTypes from 'prop-types';
import memoize from 'transmute/memoize';
import { GYPSUM } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const _getRandomInteger = (max, min) => Math.floor((max - min) * Math.random()) + min;
const getRowWidth = memoize((_, ...args) => _getRandomInteger(...args));
const ListPlaceholderSvg = props => {
  const {
      fill,
      height,
      rowHeight,
      rowMinWidth,
      rowPaddingX,
      width
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const rowOuterHight = rowHeight + rowPaddingX;
  const count = Math.max(Math.floor(height / rowOuterHight), 0);
  return /*#__PURE__*/_jsx("svg", Object.assign({}, rest, {
    height: height,
    width: width,
    children: [...Array(count).fill()].map((_, i) => /*#__PURE__*/_jsx("rect", {
      height: rowHeight,
      rx: 3,
      ry: 3,
      style: {
        fill,
        borderRadius: '3px'
      },
      width: getRowWidth(i, width, rowMinWidth),
      x: 0,
      y: rowOuterHight * i
    }, `ListPlaceholderSvg-${i}`))
  }));
};
ListPlaceholderSvg.propTypes = {
  fill: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  rowHeight: PropTypes.number.isRequired,
  rowMinWidth: PropTypes.number,
  rowPaddingX: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
ListPlaceholderSvg.defaultProps = {
  fill: GYPSUM,
  rowHeight: 14,
  rowMinWidth: 30,
  rowPaddingX: 16
};
export default ListPlaceholderSvg;